<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 24" style="enable-background:new 0 0 30 24;" xml:space="preserve">
<circle cx="12" cy="6" r="1.5"/>
<circle cx="12" cy="12" r="1.5"/>
<circle cx="12" cy="18" r="1.5"/>
<circle cx="18" cy="6" r="1.5"/>
<circle cx="18" cy="12" r="1.5"/>
<circle cx="18" cy="18" r="1.5"/>
</svg>
